module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"input-group has-feedback-left mb-2\"> <span class=\"input-group-addon input-group-addon-left\"><i class=\"fa fa-search text-secondary\"></i></span> <input type=\"text\" class=\"form-control filter-term\" placeholder=\"")
    ; __append(escapeFn( locals.placeholder ))
    ; __append("\"> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/carrier_accounts/filter/template.ejs
// module id = 1323
// module chunks = 1